export const URL_PARAMS = {
  PAGE: "page",
  PAGE_SIZE: "pageSize",
  SEARCH: "search",
  ORDER_BY: "orderBy",
  DESCENDING: "descending",
  DATE_FROM: "dateFrom",
  DATE_TO: "dateTo",
} as const;
